import React from 'react';
import { Input, Tooltip, Button, Checkbox } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';

import FormVentaSello from '../../formularios/FormVentaSello';

const FormItem = Form.Item;
const { TextArea } = Input;

class FormDeclaracionJurada extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
      existeVenta: false,
      declaracion: '',
      enteReceptor: '',
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log("Received values of form: ", values);
        this.props.onSubmit({
          declaracion: values.declaracion,
          ente_receptor: values.ente_receptor,
          existeVenta: this.state.existeVenta,
        });
      }
    });
  };

  onFinalizar = (ventaSinStock, detalles, datosPonset, extras) => {
    let datos = {
      declaracion: this.props.form.getFieldValue('declaracion'),
      ente_receptor: this.props.form.getFieldValue('ente_receptor'),
      existeVenta: this.state.existeVenta,
      detalles,
      datosPonset,
      extras,
    };

    this.props.onSubmit(datos, ventaSinStock);
  };

  onFinalizarMP = (ventaSinStock, detalles, datosMP, extras) => {
    let datos = {
      declaracion: this.props.form.getFieldValue('declaracion'),
      ente_receptor: this.props.form.getFieldValue('ente_receptor'),
      existeVenta: this.state.existeVenta,
      detalles,
      datosMP,
      extras,
    };

    this.props.onSubmit(datos, ventaSinStock);
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  onChangeCheckbox = e => {
    // console.log(`checked = ${e.target.checked}`);
    this.setState({
      ...this.state,
      existeVenta: e.target.checked,
    });
  };

  handleDeclaracionChange = e => {
    this.setState({
      declaracion: e.target.value,
    });
  };

  handleEnteChange = e => {
    this.setState({
      enteReceptor: e.target.value,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">Datos de la Declaracion</h1>

        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Declaracion de la persona
                <Tooltip title="Lo que el declarante quiere declarar ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('declaracion', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar el texto a declarar!',
                  whitespace: true,
                },
              ],
            })(<TextArea rows={6} onChange={this.handleDeclaracionChange} />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Ente Receptor
                <Tooltip title="Para quien será la declaracion ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('ente_receptor', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar el ente receptor!',
                  whitespace: true,
                },
              ],
            })(<Input onChange={this.handleEnteChange} />)}
          </FormItem>

          {this.props.config.creacion && (
            <FormItem>
              <Checkbox
                style={{ marginLeft: '30%' }}
                onChange={this.onChangeCheckbox}
                disabled={
                  this.state.enteReceptor === '' ||
                  this.state.declaracion === ''
                }
              >
                Computar Venta
              </Checkbox>
            </FormItem>
          )}

          {this.state.existeVenta && (
            <div>
              <hr />
              <FormVentaSello
                opcionRender={1}
                organismo={this.props.organismo}
                onFinalizar={(detalles, datosPonset, extras) =>
                  this.onFinalizar(false, detalles, datosPonset, extras)
                }
                crearVentaCompleta={(detalles, datosPonset, extras) =>
                  this.onFinalizar(true, detalles, datosPonset, extras)
                }
                crearVentaMercadoPago={(detalles, datosMP, extras) =>
                  this.onFinalizarMP(true, detalles, datosMP, extras)
                }
                tramite={'DECLARACIONES JURADAS'}
              />
              <hr />
            </div>
          )}

          <FormItem {...tailFormItemLayout}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={
                this.state.existeVenta ||
                this.state.enteReceptor === '' ||
                this.state.declaracion === ''
              }
            >
              <Icons.SolutionOutlined />
              Exento
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    return {
      declaracion: Form.createFormField({
        value: props.datos ? props.datos.declaracion : '',
      }),
      ente_receptor: Form.createFormField({
        value: props.datos ? props.datos.ente_receptor : '',
      }),
    };
  },
})(FormDeclaracionJurada);
